"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconFavorites = void 0;
var React = __importStar(require("react"));
var IconFavorites = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M16.6606,14.2949 C16.5496,14.4079 16.4996,14.5669 16.5246,14.7249 L17.5456,20.9979 L12.2426,18.0559 C12.1666,18.0139 12.0836,17.9919 11.9996,17.9919 C11.9166,17.9919 11.8326,18.0139 11.7576,18.0559 L6.4626,20.9569 L7.4746,14.7249 C7.5006,14.5669 7.4506,14.4079 7.3396,14.2949 L2.9986,9.8289 L8.9736,8.9129 C9.1396,8.8879 9.2806,8.7809 9.3506,8.6299 L11.9946,2.9539 L11.9966,2.9579 L14.6486,8.6299 C14.7196,8.7809 14.8606,8.8879 15.0256,8.9129 L20.9996,9.8299 L16.6606,14.2949 Z M21.9476,9.5109 C21.8276,9.1519 21.5236,8.8959 21.1526,8.8379 L15.4406,7.9619 L12.9026,2.5329 C12.5706,1.8219 11.4296,1.8219 11.0976,2.5329 L8.5586,7.9619 L2.8476,8.8379 C2.4766,8.8959 2.1716,9.1519 2.0526,9.5109 C1.9326,9.8689 2.0216,10.2589 2.2846,10.5289 L6.4476,14.8129 L5.4756,20.7959 C5.4106,21.1959 5.5716,21.5879 5.8966,21.8179 C6.2066,22.0369 6.6056,22.0599 6.9386,21.8759 L11.9996,19.0659 L17.0616,21.8759 C17.2116,21.9589 17.3746,21.9999 17.5366,21.9999 C17.7356,21.9999 17.9326,21.9389 18.1036,21.8179 C18.4286,21.5879 18.5896,21.1959 18.5246,20.7969 L17.5526,14.8129 L21.7156,10.5289 C21.9776,10.2589 22.0676,9.8689 21.9476,9.5109 L21.9476,9.5109 Z" }))); };
exports.IconFavorites = IconFavorites;
exports.IconFavorites.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconFavorites;
